import * as config from './config.js'
import { deepCopy } from '../utility/utility.js'

let api = {
	/**查询当前地址的所有父级
	 * @param {object} data2 所有地址列表（树状）
	 * @param {number} nodeId2 当前查询的地址id
	 * 
	 * @return {object} arrRes 要返回的当前查询的所有父级
	 */
	getParent(data2, nodeId2) {
		var arrRes = []
		if (data2.length == 0) {
			if (!!nodeId2) {
				arrRes.unshift(nodeId2)
			}
			return arrRes;
		}
		let rev = (data, nodeId) => {
			// console.log('data++++', data, nodeId)
			for (var i = 0, length = data.length; i < length; i++) {
				let node = data[i]
				// console.log('node--------', node.space_id, nodeId, node.space_id == nodeId)
				if (node.space_id == nodeId) {
					arrRes.unshift(node)
					rev(data2, node.parent_id)
					break
				} else {
					if (!!node.children) {
						rev(node.children, nodeId)
					}
				}
			}
			return arrRes
		}
		arrRes = rev(data2, nodeId2)
		return arrRes;
	},

	/**查询当前地址的所有子级
	 * @param {object} data 所有地址列表（非树状）
	 * @param {number} id 当前查询的地址id
	 * 
	 * @return {object} arrRes 要返回的当前查询的所有子级
	 */
	getChild(data, id) {
		let arrRes = []
		for (let i = 0; i < data.length; i++) {
			const item = data[i];
			if (item.parent_id == id) {
				arrRes.push(item)
			}
		}
		console.log('arrRes', arrRes)
		return arrRes
	},

	/**获取父级id数组
	 * 
	 * @return {object} pidArr 要返回的所有父级id数组
	 */
	getPidArr() {
		let pidArr = []
		let list = config.sceneData.list
		for (let i = 0; i < list.length; i++) {
			let item = list[i]
			if (pidArr.indexOf(item.parent_id) === -1) {
				if (item.parent_id != undefined) {
					pidArr.unshift(item.parent_id)
				}
			}
		}
		return pidArr
	},

	/** 获取当前地址的信息（id，name等）
	 * @param {number} nodeId2 当前查询的地址id
	 */
	getDetail(id) {
		let allList = deepCopy(config.sceneData.list)
		for (let i = 0; i < allList.length; i++) {
			if (allList[i].id == id) {
				return allList[i]
			}
		}
	},

	/**获取地址列表
	 * 
	 * @return {object} newList 要返回的地址列表
	 */
	getSceneList() {
		let temArr = this.getPidArr()
		let allList = deepCopy(config.sceneData.list)
		let newList = []
		// console.log('temArr', temArr)

		//获取新地址列表 （地址不超过五级）
		let rev = (num) => {
			// console.log('num____________', num)
			let afterInfo = {}, children = []
			for (let i = 0; i < [...allList].length; i++) {
				let item = allList[i]
				let p_id = temArr[num]
				if (item.space_id == p_id) {
					afterInfo = item
				} else if (item.parent_id == p_id) {
					children.push(item)
				}
			}

			// 将新增的地址信息添加到同级地址的下方
			if (afterInfo.children) {
				afterInfo.children[0].space_id = afterInfo.children[0].parent_id + (children.length + 1)
				children.push(afterInfo.children[0])
			}
			afterInfo.children = children

			if (num + 1 < temArr.length) {
				rev(num + 1)
			} else {
				newList = [afterInfo]
			}
		}
		rev(0)
		// 地址列表（树状）供其他接口使用
		config.sceneData.treeList = deepCopy(newList)
		// console.log('newList', newList)
		return newList
	},

	/**获取地址详情
	 * @param {object} data {id: number} 当前查询的地址id
	 * 
	 * @return {object} info 要返回的地址详情
	 */
	getSpaceInfo(data) {
		let id = data.space_id
		let list = deepCopy(this.getParent(config.sceneData.treeList, id))
		let ll = list.length - 1
		let resData = {
			parent: list,
			children: list[ll].children ? list[ll].children : []
		}
		return resData
	},

	/**获取设备中心某类型设备列表
	 * @param {object} data {code: string} 当前查询的设备类型
	 * 
	 * @return {object} newList 要返回的设备列表
	 */
	getEquipmentDeviceList(data) {
		let code = data.code
		let list = deepCopy(config.equipmentData.deviceList)
		let newList = []
		for (let i in list) {
			if (list[i].code === code) {
				newList.push(list[i])
			}
		}
		return newList
	}


}

/**公共请求
 * @param {object} url 请求内容
 * @param {object} url 请求参数
*/
function post(url, data) {
	data = data || '';
	return new Promise(function (resolve, reject) {
		let res = {
			data: api[url](data)
		}
		resolve(res)
	})
}


let expSceneApi = {
	// 获取地址列表
	getSceneList() {
		return post('getSceneList')
	},
	// 获取地址详情
	getSpaceInfo(data) {
		return post('getSpaceInfo', data)
	},
	// 获取设备中心某类型设备列表
	getEquipmentDeviceList(data) {
		return post('getEquipmentDeviceList', data)
	},

}


export {
	expSceneApi
}


//////////////////
// WEBPACK FOOTER
// ./static/js/exp/scene.js
// module id = wOif
// module chunks = 1